import { UserType } from '../types/user.type';

/**
 * Returns true when the user's email domain has a 'local' auth provider configured,
 * meaning they can use a password (regardless of which provider they actually used to log in).
 * Defaults to true when the value is unknown (safe fallback — shows change-password).
 *
 * Use this to conditionally show/hide features that only make sense for local accounts,
 * such as the "Change Password" option.
 */
export function useHasLocalAuth(user: UserType | undefined): boolean {
  return user?.has_local_provider ?? true;
}
